import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const Lock = props => /*#__PURE__*/_jsxs("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: [/*#__PURE__*/_jsx("path", {
    d: "M8 1.38a3.034 3.034 0 0 1 3.034 3.034v2.483H4.966V4.414A3.034 3.034 0 0 1 8 1.379Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/_jsx("path", {
    d: "M3.31 6.345h9.38a1.103 1.103 0 0 1 1.103 1.103v6.07a1.103 1.103 0 0 1-1.103 1.103H3.31a1.103 1.103 0 0 1-1.103-1.104V7.448A1.103 1.103 0 0 1 3.31 6.345Z",
    fill: "currentColor"
  })]
});

export default Lock;